import { useTranslation } from "react-i18next";
import Field from "../../../../../../components/shared/Form/Field";
import Select from "../../../../../../components/shared/inputs/Select";
import Table from "../../../components/Table";
import { useFiltersConfig } from "./useFiltersConfig";

function Filters({ option }: { option?: string }) {
    const { t } = useTranslation();
    const filters = useFiltersConfig();

    return (
        <div className="tw-flex tw-flex-col tw-h-full tw-gap-4">
            <Field
                name="defaultFilter"
                label={t("default-filter")}
                className="tw-max-w-xs tw-mb-0"
                shouldUnregister={false}
            >
                <Select>
                    {filters.map((filter: any) => (
                        <Select.Item key={filter.name} value={filter.name}>
                            {filter.label}
                        </Select.Item>
                    ))}
                </Select>
            </Field>

            <div className="tw-flex-1 tw-min-h-0">
                <Table
                    columns={filters}
                    fieldName="filters"
                    isFilter={true}
                    canSort={false}
                />
            </div>
        </div>
    );
}

export default Filters;
